import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { aW } from '@fullcalendar/core/internal-common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Board } from 'src/app/core/models/board.model';
import { BvType } from 'src/app/core/models/bv-type.model';
import { CabinetType } from 'src/app/core/models/cabinet-type.model';
import { Cabinet } from 'src/app/core/models/cabinet.model';
import { HarnessType } from 'src/app/core/models/harness-type.model copy';
import { Location } from 'src/app/core/models/location.model';
import { MonitorType } from 'src/app/core/models/monitor-type.model';
import { PrinterType } from 'src/app/core/models/printer-type.model';
import { UserType } from 'src/app/core/models/userType.models';
import { BoardTypeService } from 'src/app/core/services/board-type.service';
import { BoardService } from 'src/app/core/services/board.service';
import { BvTypeService } from 'src/app/core/services/bv-type.service';
import { CabinetTypeService } from 'src/app/core/services/cabinet-type.service';
import { CabinetService } from 'src/app/core/services/cabinet.service';
import { HarnessTypeService } from 'src/app/core/services/harness-type.service';
import { LocationService } from 'src/app/core/services/location.service';
import { LoginService } from 'src/app/core/services/login.service';
import { MonitorTypeService } from 'src/app/core/services/monitor-type.service.';
import { PrinterTypeService } from 'src/app/core/services/printer-type.service';

@Component({
  selector: 'app-cabinet',
  templateUrl: './cabinet.component.html',
  styleUrls: ['./cabinet.component.scss']
})

// /**
//  * Dashboard Component
//  */
export class CabinetComponent implements OnInit {
  readonly: boolean = false;
  term: any;
  billValidatorType: BvType[] = [];
  cabinetType: CabinetType[] = [];
  monitorType: MonitorType[] = [];
  harnessType: HarnessType[] = [];
  printerType: PrinterType[] = [];
  filteredLocations: Location[] = [];
  location: Location[] = [];
  boards: Board[] = [];
  filteredBoards: Board[] = [];
  filteredCabinets: Cabinet[] = [];
  cabinets: Cabinet[] = [];

  addEditMode: any;
  addEditFormGroup: FormGroup = new FormGroup({});
  constructor(
    private locationService: LocationService,private cabinetService: CabinetService, private boardService: BoardService, 
    private bvTypeService: BvTypeService,  private harnessService: HarnessTypeService,
    private monitorTypeService: MonitorTypeService, private cabinetTypeService: CabinetTypeService, private printerTypeService: PrinterTypeService,
    private tastr: ToastrService, private modalService: NgbModal,
    private loginService: LoginService, private router: Router
  ) {}

  // bread crumb items
  breadCrumbItems: Array<{}> = [];

  async ngOnInit(): Promise<void> {
    this.breadCrumbItems = [{ label: 'Fortune' }, { label: 'Cabinets', active: true }];
    await this.refresh();
  }

  async refresh() {
    if(this.loginService.userType == UserType.EXTERNAL) {
      this.readonly = true;
    } else {
      this.billValidatorType = await this.bvTypeService.getAll();
      this.monitorType = await this.monitorTypeService.getAll();
      this.printerType = await this.printerTypeService.getAll();
      this.cabinetType = await this.cabinetTypeService.getAll();
      this.harnessType = await this.harnessService.getAll()
      this.location = await this.locationService.getAll();
      this.boards = await this.boardService.getAll();
      this.readonly = false;
      this.updateFilteredCabinets
      this.updateFilteredBoards();
      this.updateFilteredLocations();
    }
    this.cabinets = await this.cabinetService.getAll();
    console.log("refresh called", this)
  }

  async onAddNew(modal: unknown) {
    this.addEditMode = "Add";
    this.addEditFormGroup = new FormGroup({
      id: new FormControl<string>(''),
      cabinetTag: new FormControl<string>(''),
      purchased: new FormControl<string>(''),
      boardAssetTag: new FormControl<string>(''),
      cabinetType: new FormControl<string>(''),
      printerType: new FormControl<string>(''),
      harnessType: new FormControl<string>(''),
      monitorType: new FormControl<string>(''),
      billValidatorType: new FormControl<string>(''),
      locationTag: new FormControl<string>(''),
      enabled: new FormControl<boolean>(true),
    });
    try {
      const results = await this.modalService.open(modal).result;
      console.log('add edit modal returned', {results, addEditFormGroup: this.addEditFormGroup.value});
      if(results=="Save click") {
        const newCabinetData = this.addEditFormGroup.value;
        if(newCabinetData.billValidatorType) {newCabinetData.billValidatorType = {id: newCabinetData.billValidatorType}}
        if(newCabinetData.cabinetType) {newCabinetData.cabinetType = {id: newCabinetData.cabinetType}}
        if(newCabinetData.printerType) {newCabinetData.printerType = {id: newCabinetData.printerType}}
        if(newCabinetData.harnessType) {newCabinetData.harnessType = {id: newCabinetData.harnessType}}
        if(newCabinetData.monitorType) {newCabinetData.monitorType = {id: newCabinetData.monitorType}}
        if(newCabinetData.location) {newCabinetData.location = {id: newCabinetData.location}}
        if(newCabinetData.boardAssetTag) {
          const boardAssetTag = newCabinetData.boardAssetTag.split(" ")[0]
          delete newCabinetData.boardAssetTag;
          newCabinetData.board = {assetTag: boardAssetTag}
        }
        if(newCabinetData.locationTag) {
          const locationTag = newCabinetData.locationTag.split(" ")[0]
          delete newCabinetData.locationTag;
          newCabinetData.location = {locationTag}
        }
        const cabinet = await this.cabinetService.create(newCabinetData);
        console.log(newCabinetData)
        if(cabinet != null) {
          //TODO mark sucesss
        } else {
          //TODO mark failure
        }
      } else {
        //TODO mark cancel
      }
    } catch (error) {
      //TODO mark error
    }
    await this.refresh();
  }

  async onChange() {
    console.log("onChange() called", this.addEditFormGroup.value)
  }

  async onDelete( id: string) {
    await this.cabinetService.delete(id);
    await this.refresh();
    this.tastr.error('deleted');

     
  } 

  async downloadCsv() {
    const downloadResult = await this.boardService.download();
    const a = document.createElement('a');
    a.download = downloadResult.fileName;
    a.href = window.URL.createObjectURL(new Blob([downloadResult.file], {type: "text/csv"}));
    a.click();
    window.URL.revokeObjectURL(a.href);
    await this.refresh();
    this.tastr.error('downloaded');


    }

  async onEdit(modal: unknown, original: Cabinet) {
    this.addEditMode = "Edit";
    this.addEditFormGroup = new FormGroup({
      id: new FormControl<string>(original.id),
      cabinetTag: new FormControl<string>(original.cabinetTag),
      purchased: new FormControl<string>(original.purchased),
      boardAssetTag: new FormControl<string>(original.board?.assetTag),
      cabinetType: new FormControl<string>(original.cabinetType.id),
      printerType: new FormControl<string>(original.printerType.id),
      harnessType: new FormControl<string>(original.harnessType.id),
      monitorType: new FormControl<string>(original.monitorType.id),
      billValidatorType: new FormControl<string>(original.billValidatorType.id),
      locationTag: new FormControl<string>(original.location?.locationTag),    
      enabled: new FormControl<boolean>(original.enabled),
      
    });
    try {
      const results = await this.modalService.open(modal).result;
      console.log('add edit modal returned', {results, addEditFormGroup: this.addEditFormGroup.value});
      if(results=="Save click") {
          const editCabinetData = this.addEditFormGroup.value
        if(editCabinetData.billValidatorType) {editCabinetData.billValidatorType = {id: editCabinetData.billValidatorType}}
        if(editCabinetData.cabinetType) {editCabinetData.cabinetType = {id: editCabinetData.cabinetType}}
        if(editCabinetData.printerType) {editCabinetData.printerType = {id: editCabinetData.printerType}}
        if(editCabinetData.harnessType) {editCabinetData.harnessType = {id: editCabinetData.harnessType}}
        if(editCabinetData.locationTag) {
          const locationTag = editCabinetData.locationTag.split(" ")[0]
          delete editCabinetData.locationTag;
          editCabinetData.location = {locationTag}
        }
        if(editCabinetData.monitorType) {editCabinetData.monitorType = {id: editCabinetData.monitorType}}
        if(editCabinetData.boardAssetTag) {
          editCabinetData.board = { boardAssetTag: editCabinetData.boardAssetTag.split(" ")[0] };
          editCabinetData.boardAssetTag;
        } 
        
        const cabinet = await this.cabinetService.update(original.id ,editCabinetData);

        if(cabinet != null) {
          //TODO mark sucesss
        } else {
          //TODO mark failure
        }
      } else {
        //TODO mark cancel
      }
    } catch (error) {
      //TODO mark error
    }
    await this.refresh();
  } 

  updateFilteredBoards(filter: any = null) {
    if(filter?.value){
      this.filteredBoards =  this.boards.filter(b => b.assetTag.toLowerCase().indexOf(filter.value.toLowerCase()) != -1);
    } else {
      this.filteredBoards =  this.boards;
    }
  }

  updateFilteredLocations(filter: any = null) {
    if(filter?.value){
      this.filteredLocations =  this.location.filter(l => l.locationTag.toLowerCase().indexOf(filter.value.toLowerCase()) != -1);
    } else {
      this.filteredLocations =  this.location;
    }
  }

  updateFilteredCabinets(filter: any = null) {
    if(filter?.value){
      this.filteredCabinets =  this.cabinets.filter(c => c.cabinetTag.toLowerCase().indexOf(filter.value.toLowerCase()) != -1);
    } else {
      this.filteredCabinets =  this.cabinets;
    }
  }

}
